/* ============
 * State of the project module
 * ============
 *
 * The initial state of the project module.
 */

export default {
  order: undefined,
  project: null,
  i18nTranslations: null,
};
